const PRODUCTS_BASE = '/products';
const CARDS_BASE = PRODUCTS_BASE + '/cards';
const PAYMENT_LINKS_BASE = PRODUCTS_BASE + '/payment';

const CARDS = {
    BASE: CARDS_BASE,
    COLLECTIONS: CARDS_BASE + '/collections',
    ACTIVITY: CARDS_BASE + '/activity',
    SUMMARIES: CARDS_BASE + '/summaries',
    EXPIRATIONS: CARDS_BASE + '/expirations',
    CANCELLATIONS: CARDS_BASE + '/cancellations',
    MOVEMENTS: CARDS_BASE + '/movements',
};

const PAYMENT_LINKS = {
    BASE: PAYMENT_LINKS_BASE + 'Links',
    MOVEMENTS: PAYMENT_LINKS_BASE + 'Movements',
};

const PRODUCTS = {
    BASE: PRODUCTS_BASE,
    CARDS,
    PAYMENT_LINKS,
};

const MANAGEMENT_BASE = '/managment';

const MANAGEMENT = {
    BASE: MANAGEMENT_BASE,
    CHECKER: MANAGEMENT_BASE + '/checker',
    CONSULTANTS: MANAGEMENT_BASE + '/consultants',
    CONSULTANTS_LOAD: MANAGEMENT_BASE + '/consultants/load',
    FRAUD_PREVENTION: MANAGEMENT_BASE + '/fraudPrevention',
};

const AUTH_BASE = '/auth';
const AUTH = {
    BASE: AUTH_BASE,
    LOGIN: AUTH_BASE + '/login',
    OTP: AUTH_BASE + '/otp',
    PASSWORD: AUTH_BASE + '/password',
    REGISTRATION: AUTH_BASE + '/registration',
    FORGOT_PASSWORD: AUTH_BASE + '/forgot-password',
};

const CLIENTS_BASE = '/clients';
const CLIENTS_DETAILS_BASE = CLIENTS_BASE + '/details';

const CLIENTS = {
    BASE: CLIENTS_BASE,
    DETAILS: CLIENTS_DETAILS_BASE,
};

export const ROUTES = {
    HOME: '/',
    AUTH,
    CLIENTS,
    PRODUCTS,
    MANAGEMENT,
};
